import { combineReducers } from "redux";
import authReducer from "./authReducer";
import forgotPasswordReducer from "./forgotPasswordReducer";
import userReducer from "./userReducer";
import commodityReducer from "./commodityReducer";
import consigneeReducer from "./consigneeReducer";
import shipperReducer from "./shipperReducer";
import operatorReducer from "./operatorReducer";
import deliveryReducer from "./deliveryReducer";
import kotaReducer from "./kotaReducer";
import provinsiReducer from "./provinsiReducer";
import purchaseReducer from "./purchaseReducer";
import supplierReducer from "./supplierReducer";
import resellerReducer from "./resellerReducer";
import trackReducer from "./trackReducer";
import unitReducer from "./unitReducer";
import detailpoReducer from "./detailpoReducer";
import jenisbarangReducer from "./jenisbarangReducer";
import routeReducer from "./routeReducer";
import distributionReducer from "./distributionReducer";
import portReducer from "./portReducer";
import scheduleReducer from "./scheduleReducer";
import importScheduleReducer from "./importScheduleReducer";
import bookingReducer from "./bookingReducer";
import containerReducer from "./containerReducer";
import detailcontainerReducer from "./detailcontainerReducer";
import kemasanReducer from "./kemasanReducer";
import typecontainerReducer from "./typecontainerReducer";
import depotReducer from "./depotReducer";
import jeniscommodityReducer from "./jeniscommodityReducer";
import productReducer from "./productReducer";
import vesselReducer from "./vesselReducer";
import complaintReducer from "./complaintReducer";
import msttrayekReducer from "./msttrayekReducer";
import dashboardReducer from "./dashboardReducer";
import trackingDataReducer from "./trackingDataReducer";
import manifestReducer from "./manifestReducer";
import packagingReducer from "./packagingReducer";
import priceReducer from "./priceReducer";
import biayapengurusanReducer from "./biayapengurusanReducer";
import roleReducer from "./roleReducer";
import aclReducer from "./aclReducer";
import priceconsigneeReducer from "./priceconsigneeReducer";
import activityReducer from "./activityReducer";
import masterKapalReducer from "./masterKapalReducer";
import masterHargaReducer from "./masterHargaReducer";
import masterKontrakReducer from "./masterKontrakReducer";
import kodeTrayekReducer from "./masterKodeTrayekReducer";
import R_tblTrayekBalikReducer from "./reports/R_tblTrayekBalikReducer";
import maintenanceReducer from "./maintenanceReducer";
import guestReducer from "./guesReducer";
import InfoReducer from "./infoReducer";
import ExpiredPIReducer from "./ExpiredPIReducer";
import TopConsignee from "./dashboardReducerTopConsignee";
import RekapBokingReducer from "./reportRekapBokingReducer";
import RekapPoReducer from "./reportRekapPoReducer";
import WhitelistReducer from "./whitelistReducer";
import userSource from "./masterUserSourceReducer";
import kredensial from "./masterKredensialReducer";
import Landing from "./Landing";
import BriStore from "./bristoreReducer";
import DashboardPimpinan from "./dashboardPimpinanReducer";
import MasterContainer from "./masterContainerReducer";
import MappingContainer from "./mappingContainerReducer";
import KomparasiTarif from "./komparasiTarifReducer";
import RealisasiVoyageContainer from "./realisasiVoyageContainerReducer";
import TrackingContainerReducer from "./trackingContainerReducer";
import DashboardPengaduan from "./dahsboardPengaduanReducer";
import PortalReducer from "./portalReducer";
import CronReducer from "./CronReducer";
import SizeReducer from "./sizeContainerReducer";
import JenisConsigneeBerangkatReducer from "./jenisConsigneeBerangkatReducer";
import biayaPengirimanReducer from "./biayaPengirimanReducer";
import NilaiBarangPerPelabuhanReducer from "./nilaiBarangPerPelabuhanReducer";
import OkupansiKuotaReducer from "./okupansiKuotaReducer";
import ContainerPerPortReducer from "./reportContainerPerPortReducer";
import liveChatReducer from "./liveChatReducer";
import reportNilaiBarangPerPortReducer from "./reportNilaiBarangPerPortReducer";

const tolApp = combineReducers({
    auth: authReducer,
    forgotPassword: forgotPasswordReducer,
    users: userReducer,
    commodities: commodityReducer,
    consignees: consigneeReducer,
    shippers: shipperReducer,
    operators: operatorReducer,
    deliveries: deliveryReducer,
    kotas: kotaReducer,
    provinsis: provinsiReducer,
    purchases: purchaseReducer,
    suppliers: supplierReducer,
    resellers: resellerReducer,
    tracks: trackReducer,
    units: unitReducer,
    detailpos: detailpoReducer,
    jenisbarangs: jenisbarangReducer,
    routes: routeReducer,
    distributions: distributionReducer,
    ports: portReducer,
    schedules: scheduleReducer,
    importSchedule: importScheduleReducer,
    bookings: bookingReducer,
    containers: containerReducer,
    detailcontainers: detailcontainerReducer,
    kemasans: kemasanReducer,
    typecontainers: typecontainerReducer,
    depots: depotReducer,
    jeniscommodities: jeniscommodityReducer,
    products: productReducer,
    vessels: vesselReducer,
    complaints: complaintReducer,
    msttrayeks: msttrayekReducer,
    dashboard: dashboardReducer,
    trackingData: trackingDataReducer,
    manifest: manifestReducer,
    packagings: packagingReducer,
    prices: priceReducer,
    biayapengurusans: biayapengurusanReducer,
    roles: roleReducer,
    acl: aclReducer,
    priceconsignees: priceconsigneeReducer,
    activities: activityReducer,
    kapal: masterKapalReducer,
    masterHarga: masterHargaReducer,
    kontrak: masterKontrakReducer,
    kodeTrayek: kodeTrayekReducer,
    r_trayekBalik: R_tblTrayekBalikReducer,
    maintenance: maintenanceReducer,
    guest: guestReducer,
    Info: InfoReducer,
    ExpiredPI: ExpiredPIReducer,
    DashboardTopConsignee: TopConsignee,
    RekapBoking: RekapBokingReducer,
    RekapPo: RekapPoReducer,
    Whitelist: WhitelistReducer,
    userSource: userSource,
    kredensial: kredensial,
    Landing: Landing,
    BriStore: BriStore,
    DashboardPimpinan: DashboardPimpinan,
    MasterContainer: MasterContainer,
    MappingContainer: MappingContainer,
    KomparasiTarif: KomparasiTarif,
    RealisasiVoyageContainer: RealisasiVoyageContainer,
    TrackingContainerReducer: TrackingContainerReducer,
    DashboardPengaduan: DashboardPengaduan,
    portals: PortalReducer,
    cron: CronReducer,
    sizeContainer: SizeReducer,
    JenisConsigneeBerangkatReducer: JenisConsigneeBerangkatReducer,
    biayaPengiriman: biayaPengirimanReducer,
    NilaiBarangPerPelabuhanReducer: NilaiBarangPerPelabuhanReducer,
    OkupansiKuotaReducer: OkupansiKuotaReducer,
    ContainerPerPortReducer: ContainerPerPortReducer,
    liveChats: liveChatReducer,
    ReportNilaiBarangPerPelabuhan: reportNilaiBarangPerPortReducer,
});

export default tolApp;
